var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 20,
    viewBox: "0 0 35 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8182 0H3.18182C1.43182 0 0 1.43182 0 3.18182V15.9091C0 17.6591 1.43182 19.0909 3.18182 19.0909H31.8182C33.5682 19.0909 35 17.6591 35 15.9091V3.18182C35 1.43182 33.5682 0 31.8182 0ZM31.8182 15.9091H3.18182V3.18182H31.8182V15.9091ZM7.95455 14.3182H11.1364V11.1364H14.3182V7.95455H11.1364V4.77273H7.95455V7.95455H4.77273V11.1364H7.95455V14.3182Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4772 14.3182C22.7951 14.3182 23.8635 13.2498 23.8635 11.9318C23.8635 10.6139 22.7951 9.54546 21.4772 9.54546C20.1592 9.54546 19.0908 10.6139 19.0908 11.9318C19.0908 13.2498 20.1592 14.3182 21.4772 14.3182Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.841 9.54545C29.1589 9.54545 30.2273 8.47704 30.2273 7.15908C30.2273 5.84113 29.1589 4.77272 27.841 4.77272C26.523 4.77272 25.4546 5.84113 25.4546 7.15908C25.4546 8.47704 26.523 9.54545 27.841 9.54545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.82520f5d74b4c6535f2d80097ca558af.svg";
export { ForwardRef as ReactComponent };